<script>
import Vue from 'vue'
import * as Colyseus from "colyseus.js"; // not necessary if included via <script> tag.
import {$eBus} from '@/event-bus/index'
import GameClientEvent from '@/enum/GameClientEvent'
import {ConsoleLogger} from '@/console-logger'
import AppConfig from '@/app-config'
import { WebsocketCloseCodeUtil } from './WebsocketCloseCodeUtil.js';

export default {
  name: 'game-client',
  data() {
    return {
      internalIsConnected: false,
      client: null,
      room: null,
      roomId: null,
      logMessages: [],
      playerSessionId: false, // set in this.room.onJoin
      expanded: false,
      colyseusEndPoint: null,
      logger: new ConsoleLogger('GameClient', 'background: #00aa00; color: white', null,
          !AppConfig.debug.gameClient),
    }
  },
  mounted() {
    Object.defineProperty(Vue.prototype, '$gameClient', {
      value: this,
      configurable: true
    })

    console.log('GAMECLIENT', this);

    this.logMessage(`Assigned to Vue.$gameClient`)
  },
  watch: {
    phase() {
      let newPhase = this.phase

      if (newPhase) {
        this.logMessage(`Phase changed! New phase: ${newPhase}`)

        $eBus.$emit(GameClientEvent.PhaseChanged, newPhase)
      }
    },
    roomId() {
      $eBus.$emit(GameClientEvent.CustomRoomIdChanged, this.roomId)
    }
  },
  computed: {
    phase() {
      try {
        return this.room.state.phase
      } catch (error) {
        return null
      }
    }
  },
  methods: {
    isPhase(phase) {
      if (Array.isArray(phase)) {
        return phase.includes(this.phase)
      } else {
        return phase === this.phase
      }
    },

    isMe(playerId) {
      return playerId === this.playerSessionId
    },

    // Logger
    clearLog() {
      console.log('Clearing log!')

      this.logMessages = []
    },
    logMessage(message) {
      this.logger.logMessage(message)

      this.logMessages.push(message)
    },

    // Game client control
    async connect(host, port, wsProtocol) {
      let colyseusHostWithPort = `${host}:${port}`

      let colyseusUrl = (wsProtocol || 'ws') + '://' + colyseusHostWithPort

      this.colyseusEndPoint = colyseusUrl

      $eBus.$emit(GameClientEvent.EndPointChanged, colyseusHostWithPort)

      this.logMessage(`Connecting to ${colyseusUrl}`)

      try {
        this.client = new Colyseus.Client(colyseusUrl);

        $eBus.$emit(GameClientEvent.Open, this.client)

        this.internalIsConnected = true;
      } catch (e) {
        $eBus.$emit(GameClientEvent.Error, this.client, e)
      }

/*
      this.client.onError.add((error) => {
        this.logMessage(GameClientEvent.Error + ': ' + error)

        $eBus.$emit(GameClientEvent.Error, this.client, error)

        this.internalIsConnected = false
      })

      this.client.onClose.add(() => {
        this.logMessage(GameClientEvent.Close)

        $eBus.$emit(GameClientEvent.Close, this.client)

        this.internalIsConnected = false
      })

      this.client.onOpen.add(() => {
        this.logMessage(GameClientEvent.Open)

        $eBus.$emit(GameClientEvent.Open, this.client)

        this.internalIsConnected = true
      })*/
    },
    onRoomJoined(room, onJoin = null) {
      room.onStateChange((state) => {
        this.logMessage(GameClientEvent.RoomStateChange)
        this.logMessage(JSON.stringify(state, null, 2))

        if (state.customId && this.roomId !== state.customId) {
          this.roomId = state.customId;
        }

        $eBus.$emit(GameClientEvent.RoomStateChange, room, state)
      });

      room.onMessage((message) => {
        this.logMessage(GameClientEvent.RoomMessage + ': ' + message)

        $eBus.$emit(GameClientEvent.RoomMessage, room, message)
      });

      room.onLeave((code) => {
        // https://github.com/Luka967/websocket-close-codes#websocket-close-codes
        let codeString = WebsocketCloseCodeUtil.getErrorCodeString(code);

        this.logMessage(GameClientEvent.RoomLeave + ': ' + code + ' (' + codeString + ')');

        if (codeString) {
          // If we have a code string it must be a real websocket close error, let's disconnect if we can
          this.disconnect(code, codeString);
        } else {
          $eBus.$emit(GameClientEvent.RoomLeave, room, code)
        }
      });

      room.onError((code, error) => {
        this.logMessage(GameClientEvent.RoomError + ': ' + error)

        $eBus.$emit(GameClientEvent.RoomError, room, error)
      });

      this.playerSessionId = room.sessionId

      this.logMessage(GameClientEvent.RoomJoin)

      $eBus.$emit(GameClientEvent.RoomJoin)

      if (onJoin) {
        onJoin(this.room)
      }

      $eBus.$emit(GameClientEvent.RoomCreated, room)
    },
    async joinOrCreateRoom(roomId, onJoin = null, onError = null) {
      this.roomId = roomId

      let colyseusOptions = {
        customId: roomId
      };

      try {
        console.log('joinOrCreate.game', colyseusOptions);
        this.room = await this.client.joinOrCreate('game', colyseusOptions)

        console.log("joined successfully", this.room);

        this.onRoomJoined(this.room, onJoin);
      } catch (e) {
        console.error('join error', e);

        if (onError) {
          onError(e);
        }
      }
    },
    async joinRoom(roomId, onJoin = null, onError = null) {
      this.roomId = roomId

      let colyseusOptions = {
        customId: roomId
      };

      try {
        console.log('join.game', colyseusOptions);
        this.room = await this.client.join('game', colyseusOptions)

        console.log("joined successfully", this.room);

        this.onRoomJoined(this.room, onJoin);
      } catch (e) {
        console.error('join error', e);

        if (onError) {
          onError(e);
        }
      }
    },
    leaveRoom() {
      if (this.room) {
        this.logMessage('Leaving room..')

        this.room.leave()

        this.room = null
      }
    },
    inRoom() {
      return !!this.room
    },
    isConnected() {
      return this.internalIsConnected;
    },
    isClientConnected() {
      return this.isConnected() || this.inRoom();
    },
    send(data) {
      if (!this.room) {
        throw new Error('Cannot send message as we are no longer in room!');
      }

      this.logMessage('Sending data')
      this.logMessage(JSON.stringify(data, null, 2))

      this.room.send('data', data);
    },
    disconnect(code = null, codeString = null) {
      this.logMessage('Disconnecting..')

      this.leaveRoom()

      this.internalIsConnected = false
      //this.closeConnection()

      this.logMessage('Disconnected!')

      $eBus.$emit(GameClientEvent.Disconnected, code, codeString);
      $eBus.$emit(GameClientEvent.Close, code, codeString);
    },
    closeConnection() {
      if (this.client) {
        this.logMessage('Closing client connection..')

        this.client.close()

        this.client = null
      }

      console.log('CLOSING CONNECTION');
      this.internalIsConnected = false
    }
  },
  render: function (h) {
    return h() // avoid warning message
  }
}
</script>